import ContactForm from "@/components/contact/ContactForm";
import ContactAside from "@/components/contact/ContactAside";

export default function Contact() {
  return (
    <main className="bg-ivory text-ink">
      <section className="pt-40 md:pt-52 pb-16 max-w-[1480px] mx-auto px-6 md:px-12">
        <div className="eyebrow mb-8">A conversation, not a form</div>
        <h1 className="font-serif text-6xl md:text-[7.5rem] tracking-tighter font-light leading-[0.92]">
          Begin the <br />
          <em className="italic text-indigo_deep">conversation.</em>
        </h1>
        <p className="mt-10 max-w-xl text-lg text-ink/70 font-light leading-relaxed">
          Tell us a little about how you wish to travel. A curator will reply
          personally — usually within two working days, always by name.
        </p>
      </section>

      <section className="py-16 md:py-24 max-w-[1480px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-12">
        <ContactForm />
        <ContactAside />
      </section>
    </main>
  );
}
